import { authFetch } from './api';
import { saveAs } from 'file-saver';

export const invoiceService = {
  async downloadInvoicePDF(invoiceId) {
    try {
      const response = await authFetch(`/invoices/${invoiceId}/pdf`);
      
      if (!response.ok) {
        // Try to get error details from response
        let errorMessage = 'Failed to download PDF';
        try {
          const errorData = await response.json();
          errorMessage = errorData.message || errorMessage;
        } catch (parseError) {
          // If we can't parse the error response, use status text
          errorMessage = response.statusText || errorMessage;
        }
        throw new Error(errorMessage);
      }
      
      const blob = await response.blob();
      
      // Check if blob is empty or invalid
      if (blob.size === 0) {
        throw new Error('Generated PDF is empty. Please try again.');
      }
      
      const filename = response.headers.get('content-disposition')
        ?.split('filename=')[1]
        ?.replace(/"/g, '') || `invoice-${invoiceId}.pdf`;
      
      saveAs(blob, filename);
      return true;
    } catch (error) {
      console.error('PDF download error:', error);
      
      // Provide more specific error messages
      let userMessage = 'Failed to download PDF';
      if (error.message.includes('Browser session ended unexpectedly')) {
        userMessage = 'PDF generation failed due to system resources. Please try again in a moment.';
      } else if (error.message.includes('timeout')) {
        userMessage = 'PDF generation timed out. Please try again.';
      } else if (error.message.includes('Browser dependencies')) {
        userMessage = 'PDF generation service is temporarily unavailable. Please contact support.';
      } else if (error.message.includes('empty')) {
        userMessage = 'Generated PDF is empty. Please try again.';
      } else if (error.message) {
        userMessage = error.message;
      }
      
      alert(userMessage);
      throw error;
    }
  },

  async previewInvoicePDF(invoiceId) {
    try {
      const response = await authFetch(`/invoices/${invoiceId}/pdf/preview`);
      
      if (!response.ok) {
        // Try to get error details from response
        let errorMessage = 'Failed to preview PDF';
        try {
          const errorData = await response.json();
          errorMessage = errorData.message || errorMessage;
        } catch (parseError) {
          // If we can't parse the error response, use status text
          errorMessage = response.statusText || errorMessage;
        }
        throw new Error(errorMessage);
      }
      
      const blob = await response.blob();
      
      // Check if blob is empty or invalid
      if (blob.size === 0) {
        throw new Error('Generated PDF is empty. Please try again.');
      }
      
      return URL.createObjectURL(blob);
    } catch (error) {
      console.error('PDF preview error:', error);
      
      // Provide more specific error messages
      let userMessage = 'Failed to preview PDF';
      if (error.message.includes('Browser session ended unexpectedly')) {
        userMessage = 'PDF generation failed due to system resources. Please try again in a moment.';
      } else if (error.message.includes('timeout')) {
        userMessage = 'PDF generation timed out. Please try again.';
      } else if (error.message.includes('Browser dependencies')) {
        userMessage = 'PDF generation service is temporarily unavailable. Please contact support.';
      } else if (error.message.includes('empty')) {
        userMessage = 'Generated PDF is empty. Please try again.';
      } else if (error.message) {
        userMessage = error.message;
      }
      
      alert(userMessage);
      throw error;
    }
  }
}; 